import './Private.scss'
import React, { Component } from 'react'
import { Outlet } from 'react-router-dom'
import { withRouter } from '../../helpers/withRouter'
import { Layout } from 'antd'
import { Content, Footer, Header, BillingAlert, WhatsAppButton, UploadProgressToast } from './components'
import { globalContext } from '../../contexts'

class LayoutPrivate extends Component {
  static contextType = globalContext;

  state = {
    currentPageId: '',
    // hotjar: null
  }

  async componentDidMount() {
    this.setCurrentPageId()
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const currentPageId = this.setCurrentPageId()

      await this.setState({ currentPageId })

      this.clearActiveTab()
    }
  }

  setCurrentPageId() {
    const {userParams, currentUser} = this.context;
    const pathname = this.props.location.pathname.substr(1)
    const currentPage = pathname.split('/')[0] === 'perfil' ? 'consulta' : pathname.split('/')[0]
    let currentPageId = pathname === '' || pathname.startsWith('callback') ? 'inicio' : currentPage
    if(currentPageId === 'consulta') {
      if(userParams?.system?.mfa === 'requerido' || (userParams?.system?.mfa === 'opcional' && currentUser.cliente?.modules?.includes('MFAOPT'))) {
        if(!currentUser.hasMfaKey) {
          if(userParams?.system?.mfa === 'requerido' || (userParams?.system?.mfa === 'opcional' && currentUser.cliente?.modules?.includes('MFAOPT') && currentUser.cliente?.modules?.includes('MFAREQ'))) {
            currentPageId = 'inicio'
          }
        }else if(!currentUser.authenticatedWith2FA){
          currentPageId = 'inicio'
        }
      }
    }

    let elems = document.getElementsByClassName('layout-private');
    if(elems.length > 0) elems[0].id = currentPageId

    return currentPageId
  }

  clearActiveTab() {
    const tabs = document.querySelectorAll('.ant-menu-item')
    
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('ant-menu-item-selected')
    }
  }

  render() {
    const { currentUser, logoutHandler } = this.props

    return (
      <Layout className="layout-private">
        <Header
          currentUser={ currentUser }
          logoutHandler= { logoutHandler }
          />

        { currentUser.cliente && currentUser.cliente.showBillingNotice === true &&
          <BillingAlert
              currentUser={ currentUser }/>
        }

        <Content>
          <Outlet />
        </Content>
        <Footer currentUser={ currentUser }/>
        <WhatsAppButton />
        <UploadProgressToast />
      </Layout>
    )
  }
}

export default withRouter(props => <LayoutPrivate {...props} />)
